module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Medium-685e3964f0ee24db8790427e324642a9.svg";